export interface Container {
	id: number;
	name: string;
	size: number;
	type: string | null;
}
